import { ViewController } from 'ionic-angular/navigation/view-controller';
import { BllOrtak } from './../../../providers/bll/bll-ortak';
import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Ortak } from '../../../providers/ortak';



@Component({
  selector: 'page-hareketdetay',
  templateUrl: 'hareketdetay.html',
})
export class HareketdetayPage {
  vwHareket: any = {};
  hareket: any = {};
  kasahareket: any = { KasaID: "", Sign: "", CardRef: "", Tutar: "", SlsMan: "", Text: "", AciklamaRef: 1,FaturaKesildiMi:"false" };
  islemListesi = [];
  islemyapan = this.ortak.aktifKullaniciAdi;
  aranan = "";
  skip: number = 0;
  take: number = 100;
  cari: any = {};
  constructor(public navCtrl: NavController,
    public bllOrtak: BllOrtak,
    public ortak: Ortak,
    public viewCtrl: ViewController,
    public navParams: NavParams) {
    if (navParams.get("vwHareket") != null) {
      this.vwHareket = navParams.get("vwHareket");
      var data = new FormData();
      data.append("hareket_id", this.vwHareket.ID);
      this.bllOrtak.islem(data, "CariHareketiGetirById", "", false).then(a => {
        var Sonuc = <any>a;
        this.hareket = Sonuc.SonucObject;
        var data2 = new FormData();
        data2.append("cari_id", this.vwHareket.CariKartID);
        this.bllOrtak.islem(data2, "CariGetirByID", "", false).then(b => {
          var Sonuc2 = <any>b;
          this.cari = Sonuc2.SonucObject;
        })
      }
      )
    }
    this.islemturleri();
  }


  kapat() {
    this.viewCtrl.dismiss();
  }
  kaydet() {

    if (this.hareket.IslemTuru == 4) {
      this.tahodekaydet();
    }
    else if (this.hareket.IslemTuru == 3) {
      this.tahodekaydet();
    }
  
    else if (this.hareket.IslemTuru == 2) {
      this.dekontkaydet();
    }
    else if (this.hareket.IslemTuru == 1) {
      this.dekontkaydet();
    }

  }
  islemturleri() {

    this.bllOrtak.islemWithoutPost("IslemTurleri", "", false).then(a => {
      var sonuc = <any>a;
      this.islemListesi = sonuc.SonucObject;
    })
  }
  tahodekaydet() {
    var formData = new FormData();
    if (this.hareket.IslemTuru == 3) {
      this.hareket.Sign = 1;
      // this.hareket.Text = "Mobilden yapılan Ödeme";
      this.hareket.IslemCode = "Ödeme";
      this.kasahareket.IslemTuru = 3;
      this.kasahareket.Sign = 0;
    }
    else if (this.hareket.IslemTuru == 4) {
      this.hareket.Sign = 0;
      // this.hareket.Text = "Mobilden yapılan tahsilat";
      this.hareket.IslemCode = "Tahsilat";
      this.kasahareket.IslemTuru = 4;
      this.kasahareket.Sign = 1;
    }
   
    formData.append("CariTah_json", JSON.stringify(this.hareket));
    this.kasahareket.KasaID = 1;
    this.kasahareket.Tutar = this.hareket.Tutar;
    this.kasahareket.CardRef = this.hareket.CariKartID;
    this.kasahareket.Text = this.hareket.Text;
    this.kasahareket.AciklamaRef = 1;
    this.kasahareket.ID = this.hareket.KsCardRef;
    formData.append("Kasa_json", JSON.stringify(this.kasahareket));
    this.bllOrtak.islem(formData, "CariTahsilat", "", false).then(a => {
      var sonuc = <any>a;
      if (sonuc.Sonuc == 1) this.ortak.showBasicAlert("Başarılı", "İşlem Başarılı");
      this.viewCtrl.dismiss();
    })

  }
  dekontkaydet() {
    var formData = new FormData();
    if (this.hareket.IslemTuru = 2) {
      this.hareket.Sign = 0;
      // this.hareket.Text = "Mobilden Yapılan Alacak Dekontu";
      // this.hareket.IslemCode = "Alacak Dekontu";

    }
    else if (this.hareket.IslemTuru = 1) {
      this.hareket.Sign = 1;
      // this.hareket.Text = "Mobilden Yapılan Borç Dekontu";
      // this.hareket.IslemCode = "Borç Dekontu";
    }
    formData.append("CariTah_json", JSON.stringify(this.hareket));
    this.bllOrtak.islem(formData, "CariDekont", "", false).then(a => {
      var sonuc = <any>a;
      if (sonuc.Sonuc == 1) this.ortak.showBasicAlert("Başarılı", "İşlem Başarılı");
      this.viewCtrl.dismiss();

    })

  }

}



// WEBPACK FOOTER //
// ./src/pages/CariIslemleri/hareketdetay/hareketdetay.ts